import React from 'react'
import styled from 'styled-components'

import { colorRed } from '../../Global/global-styles'
import icon from './aex_hands_up.svg'

import Icon from '../../Components/Icon/Icon'
import EventPage from '../../Components/EventPage/EventPage'
import EventTexts from '../../Components/EventTexts/EventTexts'

const CiticalState: React.FC<{
    messageEn: string
    messageSv: string
}> = ({ messageEn, messageSv }) => {
    return (
        <CriticalPageWrapper>
            <EventPage>
                <Icon icon={icon} alt="Hand doing stop sign" />
                <EventTexts title="No trains" message={messageEn} description={messageSv} />
            </EventPage>
        </CriticalPageWrapper>
    )
}

export default CiticalState

const CriticalPageWrapper = styled.div`
    background: ${colorRed};
`
